<template>
  <!--
    	作者：kmdshop
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加门店-->
      <div class="common-form">添加商城</div>

      <el-form-item label="是否开启商城">
        <el-radio-group v-model="form.setting.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">不开启</el-radio>
        </el-radio-group>
        <div>开启后，会一键创建商城，api</div>
      </el-form-item>

      <div v-if="form.setting.status == 1">
        <el-form-item label="门店名称/手机号" prop="app_id">
          <el-input style="width: 200px;" v-model="api_val"  placeholder="门店名称/手机号"></el-input>

          <el-button type="primary" icon="el-icon" @click="quickGet">快捷获取</el-button>

          <el-button type="primary" icon="el-icon" @click="queryStore">查看门店</el-button>

          <div>
            一物一码中转站登录账户密码：kangcai/123456
          </div>
        </el-form-item>


        <el-form-item label="一物一码门店ID" prop="setting.name" >
          {{ form.setting.ywym_store_id }}
        </el-form-item>

        <el-form-item label="商城名称" prop="setting.name" :rules="[{required: true,message: '请输入商城名称'}]">
          <el-input style="width: 200px;" v-model="form.setting.name"  placeholder="商城名称"></el-input>
        </el-form-item>

        <el-form-item label="商城手机号" prop="setting.mobile" :rules="[{required: true,message: '请输入商城手机号'}]">
          <el-input style="width: 200px;" v-model="form.setting.mobile"  placeholder="商城手机号"></el-input>
        </el-form-item>

        <el-form-item label="商城站点ID" prop="setting.r_api_id" :rules="[{required: true,message: '请输入商城站点ID'}]">
          <el-input style="width: 200px;" v-model="form.setting.r_api_id"  placeholder="商城站点ID"></el-input>
        </el-form-item>

        <el-form-item label="网站域名" prop="setting.api_domain" :rules="[{required: true,message: '请输入网站域名'}]">
          <el-input style="width: 200px;" v-model="form.setting.api_domain"  placeholder="网站域名"></el-input>
        </el-form-item>

        <el-form-item label="账户" prop="setting.api_account"  :rules="[{required: true,message: '请输入账户'}]">
          <el-input style="width: 200px;" v-model="form.setting.api_account"  placeholder="账户"></el-input>
        </el-form-item>

        <el-form-item label="密钥" prop="setting.api_secret" :rules="[{required: true,message: '请输入密钥'}]">
          <el-input style="width: 200px;" v-model="form.setting.api_secret"  placeholder="密钥"></el-input>
        </el-form-item>
    </div>

    <div class="common-form">
        绑定业务员
    </div>
    <el-form-item label="选择业务员">
        <el-row>
          <el-button @click="addSClick" icon="el-icon-plus">选择业务员</el-button>
          <div>
            {{ suser_info.real_name }} - {{ suser_info.mobile }}
          </div>
          <div>
            门店添加成功后，业务员绑定独立商城，业务员可盘点门店库存
          </div>
        </el-row>
      </el-form-item>


    <div class="common-form">
        门店基础设置
    </div>
    <el-form-item label="选择店长">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择店长</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
            门店添加成功后，该用户自动成为店长
          </div>
        </el-row>
      </el-form-item>


      <el-form-item label="门店名称" prop="store_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.store_name" placeholder="请输入门店名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo_image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="联系人" prop="linkman" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.linkman" placeholder="请输入门店联系人" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.phone" placeholder="请输入门店联系电话" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">地址</div>
      <el-form-item label="门店区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>
        <!--<el-select v-if="form.region_id > 0" v-model="form.town_id" placeholder="镇">-->
        <!--  <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['town']"-->
        <!--    :key='index3'></el-option>-->
        <!--</el-select>-->
        <!--<el-select v-if="form.town_id > 0" v-model="form.village_id" placeholder="乡">-->
        <!--  <el-option :label="item4.name" :value="item4.id" v-for="(item4,index4) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['town'][form.town_id]['village']"-->
        <!--    :key='index4'></el-option>-->
        <!--</el-select>-->

      </el-form-item>
      <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

           <!--添加-->
           <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>
           <GetSUser :is_open="open_adds" @close="closeSDialogFunc"></GetSUser>
  </div>
</template>

<script>
  import Getpoint from '@/components/map/Getpoint.vue';
  import StoreApi from '@/api/store.js';
  // import select_region from '@/utils/select.region.js';
  import select_region from '@/utils/select.district.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  import GetSUser from '@/components/user/GetSUser.vue';
  export default {
    components: {
      /*腾讯地图拾取器*/
      Getpoint,
      Upload,
      GetUser,
      GetSUser
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          user_id:0,
          store_name:"",
          logo_image_id:0,
          linkman:"",
          phone:"",
          province_id: '',
          city_id: '',
          region_id: '',
          town_id: '',
          village_id: '',
          address: '',
          coordinate: '',
          suser_id:0,
     
          setting:{
            "name":"",
            "mobile":"",
            "status":1,
            "r_api_id":0,
            "api_domain":"",
            "api_account":"",
            "api_secret":"",
            "ywym_store_id":0,
            
          }
        },

        file_path: '',
        /*省市区*/
        areaList: select_region,
        /*是否上传图片*/
        isupload: false,
        open_add:false,
        loading:false,

        open_adds:false,


        suser_info:{},
        user_info:{},

        api_val:"",//门店名称/手机号
      };
    },
    created() {
      /*引用的select_region 初始化*/
      // console.log(select_region);
    },

    methods: {
      
      /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },

      addSClick(){
        this.open_adds = true;
      },
    /*关闭获取业务员弹窗*/
    closeSDialogFunc(e) {
        if (e.type != 'error') {
          this.suser_info = e.params[0];
          this.form.suser_id = e.params[0].shop_user_id;
        }
        this.open_adds = false;
      },
      queryStore(){
        // 创建一个新的浏览器窗口
        var newWindow = window.open('', '_blank');
        // 如果新窗口打开成功，设置新窗口的 location 属性
        if (newWindow) {
            newWindow.location.href = 'http://kmdapi.gzkcyj.com/shop/#/plus/oioc/index';
        } else {
            // 如果新窗口打开失败，可以在此处给用户提示或者执行其他操作
            alert('弹窗被阻止，请检查浏览器设置。');
        }

      },
      quickGet(){
        let self = this;
        self.loading = true;
            StoreApi.quickGetStore({
              api_val:self.api_val,
            }, true)
              .then(data => {
                self.loading = false;
                console.log('data',data)
                if (data.code == 1) {
                  self.form.setting = data.data
                  self.form.store_name =  data.data.name;
                  self.form.phone =  data.data.mobile;
                  self.form.linkman =  data.data.mobile;
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.addShops(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push('/store/store/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*上传*/
      openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          if(this.file_type=='qrcode'){
            this.form.store_qrcode = e[0].file_path;
          }else{
            this.file_path = e[0].file_path;
            this.form.logo_image_id = e[0].file_id;
          }
          
        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/store/addshop.vue